import React, { Component } from 'react'
import SectionControls from 'components/controls/section-controls'
import { connect } from 'react-redux'

import {
	openModal,
	getZipOfFiles,
	togglePreference,
	setFileFolder,
	setFolderParent
} from 'state/actions'

import { Route, withRouter, matchPath } from 'react-router'

import ProjectFile from './project-file'
import ProjectFileFolders from './project-file-folders'

import {
	getCurrentUser,
	getCurrentAccount
} from 'state/selectors'

import AlertBanner from 'components/alerts/alert-banner'

import MobileFooterButtons from 'components/mobile/footer-buttons'
import DropZoneIndicator from 'components/drop-zone-indicator/drop-zone-indicator'

import {
	isMobile,
	assessVisibleRows,
	parseFileArray,
	eventContainsFiles,
	getFileExtension,
} from 'utils'

import { forIn, find, chunk, times } from 'lodash'
import { createSelector } from 'reselect'

import ListHeading from 'components/list-heading/list-heading'

import isEqual from 'react-fast-compare'

import { Container, Draggable } from 'react-smooth-dnd'

class ProjectFiles extends Component {
	state = {
		isList: 0,
		searchTerm: '',
		isVisible: false,
		isDownloadLoading: false,
		blockFileTransition: false,
		isButtonsForcedShut: false,
		visibleRows: [0, 1],
		lastRenderedIndex: 5,
		isDraggingFileOver: false, // for literal uploads
		currentlyDraggedObject: null, // for 'file' objects
		sortingData: {
			column: 'name',
			direction: 'asc'
		}
	}

	cellHeight = 0
	numberOfColumns = isMobile() ? 2 : 5
	visibilityInterval = null
	listRefs = []
	lastHoveredFileFolder = null

	toggleOptions = [
		{
			name: 'Grid view'
		},
		{
			name: 'List view'
		}
	]

	visibilityFilteredFiles = []
	itemScrollOffsets = []
	tileRefs = []

	UNSAFE_componentWillMount() {
		document.addEventListener('scroll', this.handleScroll, false)
		document.addEventListener('mouseup', this.handeMouseUp)

		this.setState({
			isList: this.props.userData.files_view_toggled ? 1 : 0
		})
	}

	componentWillUnmount() {
		document.removeEventListener('scroll', this.handleScroll, false)
		document.removeEventListener('mouseup', this.handeMouseUp)

		clearInterval(this.visibilityInterval)
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		let isPropsEqual = isEqual(this.props, nextProps)
		let isStateEqual = isEqual(this.state, nextState)

		if (isPropsEqual && isStateEqual) {
			return false
		}

		return true
	}

	componentDidMount = _ => {
		setTimeout(_ => {
			this.setState({
				isVisible: true
			})

			this.handleScroll()
		}, 70)

		this.visibilityInterval = setInterval(_ => {
			this.assessVisibleRows(true)
		}, 1500)

		const openedFileId = this.getOpenedFileId()

		if (openedFileId) {
			this.openPreviewModal(null, openedFileId)
		}
	}

	getOpenedFileId = _ => {
		const {
			location
		} = this.props

		const pathSegments = location.pathname.split('/')

		const lastSegment = pathSegments[pathSegments.length - 1]
		const lastSegmentInt = parseInt(lastSegment)

		return isNaN(lastSegmentInt) ? null : lastSegmentInt
	}

	handleScroll = _ => {
		this.assessVisibleRows()
	}

	assessVisibleRows = (overrideThrottle = false) => {
		if (this.listRefs.length) {
			assessVisibleRows(this.tileRefs, this.listRefs, this.cellHeight, overrideThrottle, this.updateState, this.state.lastRenderedIndex, this.state.visibleRows, this.setCellHeight, this.state.isList)
		}
	}

	setSorting = column => {
		const {
			sortingData
		} = this.state

		let direction = 'asc'

		if (sortingData.column === column) {
			direction = sortingData.direction == 'asc' ? 'desc' : 'asc'
		}

		const newSortingData = {
			column,
			direction
		}

		this.setState({
			sortingData: newSortingData
		})
	}

	updateState = state => {
		this.setState(state)
	}

	setButtonsForcedShut = isForcedShut => {
		this.setState({
			isButtonsForcedShut: isForcedShut
		})
	}

	toggleView = _ => {
		let newToggleState

		this.props.togglePreference(this.props.userData, 'files_view')

		if (this.state.isList == 0) {
			newToggleState = 1

			this.numberOfColumns = 1
		} else {
			newToggleState = 0

			this.numberOfColumns = isMobile() ? 2 : 5
		}

		this.setState({
			blockFileTransition: true
		})

		setTimeout(_ => {
			this.setState({
				isList: newToggleState
			}, _ => {
				this.setState({
					blockFileTransition: false
				})
			})
		}, 150)
	}

	onSearchTermChange = searchTerm => {
		this.setState({
			searchTerm
		})
	}

	uploadFile = versions => {
		const {
			currentProject,
			openModal,
			currentTask
		} = this.props

		const modalData = {
			task: currentTask,
			file: null,
			versions,
			project_id: currentProject.id,
			uploaded_to_task: true,
			file_folder_id: this.getCurrentFolderId()
		}

		openModal('upload', 'task_file', modalData)
	}

	getCurrentFolderId = _ => {
		const {
			projectFolderChain
		} = this.props

		return (projectFolderChain && projectFolderChain.length) ? projectFolderChain[(projectFolderChain.length - 1)] : null
	}

	downloadZip = _ => {
		this.setState({
			isDownloadLoading: true
		})

		const {
			currentProject,
			getZipOfFiles,
		} = this.props

		getZipOfFiles(currentProject.id, this.getCurrentFolderId(), _ => {
			this.setState({
				isDownloadLoading: false
			})
		})
	}

	openPreviewModal = (index, id = null) => {
		const {
			allFiles,
			openModal,
			match
		} = this.props

		const files = this.visibilityFilteredFiles ? this.visibilityFilteredFiles.map(tempFile => {
			return tempFile ? allFiles[tempFile.id] : null
		}).filter(Boolean) : []

		if (!index) {
			files.some((file, loopedIndex) => {
				if (file.id === id) {
					index = loopedIndex

					return true
				}
			})
		}

		openModal('preview', 'files', {
			files,
			startIndex: index,
			path: match.path
		})
	}

	handleDrop = e => {
		e.preventDefault()
		e.stopPropagation()

		const dt = e.dataTransfer
		const files = dt.files

		const fileArray = []

		if (files) {
			forIn(files, file => {
				if (typeof file == 'object') {
					fileArray.push(file)
				}
			})
		}

		if (fileArray) {
			parseFileArray(fileArray, this.uploadFile)
		}

		this.setState({
			isDraggingFileOver: false
		})
	}

	handleDragOver = (e, isLeave = false) => {
		e.preventDefault()
		e.stopPropagation()

		if (!isLeave) {
			if (eventContainsFiles(e) && !this.state.isDraggingFileOver) {
				this.setState({
					isDraggingFileOver: true
				})
			}
		} else {
			this.setState({
				isDraggingFileOver: false
			})
		}
	}

	createFileFolder = _ => {
		const {
			openModal,
			accountData,
			projectFolderChain,
			currentProject
		} = this.props

		openModal('create', 'file_folder', {
			account_id: accountData.id,
			folderChain: projectFolderChain,
			isFileFolder: true,
			currentProject
		})
	}

	setCellHeight = height => {
		this.cellHeight = height
	}

	onDragStart = e => {
		if (e.isSource) {
			this.setState({
				currentlyDraggedObject: e.payload
			})
		}
	}

	handeMouseUp = _ => {
		setTimeout(_ => {
			this.lastHoveredFileFolder = null

			if (this.state.currentlyDraggedObject) {
				this.setState({
					currentlyDraggedObject: null
				})
			}
		}, 350)
	}

	onDragEnd = e => {
		if (e.isSource) {
			const {
				currentlyDraggedObject
			} = this.state

			const {
				setFileFolder,
				setFolderParent
			} = this.props

			this.setState({
				currentlyDraggedObject: null
			})

			if (currentlyDraggedObject) {
				if (this.lastHoveredFileFolder) {
					switch (currentlyDraggedObject.type) {
						case 'file':
							setFileFolder(currentlyDraggedObject.object.id, this.lastHoveredFileFolder.id)
							break
						case 'folder':
							if (currentlyDraggedObject.object.id !== this.lastHoveredFileFolder.id) {
								setFolderParent(currentlyDraggedObject.object.id, this.lastHoveredFileFolder.id)
							}
							break
					}
				}
			}
		}
	}

	onDrop = _ => {

	}

	setlastHoveredFileFolder = (object, isLeaving) => {
		const {
			currentlyDraggedObject
		} = this.state

		if (isLeaving) {
			return this.lastHoveredFileFolder = null
		}

		// i.e, are you currently dragging?
		if (currentlyDraggedObject) {
			return this.lastHoveredFileFolder = object
		}
	}

	editFileFolder = folder => {
		const {
			openModal,
			currentProject,
			projectFolderChain,
			accountData
		} = this.props

		openModal('edit', 'file_folder', {
			folder,
			account_id: accountData.id,
			folderChain: projectFolderChain,
			isFileFolder: true,
			currentProject
		})
	}

	deleteFileFolder = folder => {
		const {
			openModal
		} = this.props

		openModal('delete', 'file_folder', { folder })
	}

	render() {
		// Reset item scroll offsets every render
		this.itemScrollOffsets = []

		const {
			blockFileTransition,
			isVisible,
			isDownloadLoading,
			searchTerm,
			isButtonsForcedShut,
			visibleRows,
			lastRenderedIndex,
			isDraggingFileOver,
			sortingData,
			currentlyDraggedObject
		} = this.state

		const isList = isMobile() ? 0 : this.state.isList

		const {
			currentProject,
			allFiles,
			users,
			history,
			isArchivedProject,
			projectFolderChain,
			allFileFolders,
			updateProjectFolderChain,
		} = this.props

		let className = 'project-files'

		if (isDraggingFileOver) {
			className += ' dragging-file'
		}

		let buttonProps = [
			{
				size: 'big',
				level: 'high',
				callback: (files, previewUrl) => {
					this.uploadFile(files, previewUrl)
				},
				label: 'Upload files',
				icon: 'upload',
				hasFile: true,
				disabled: isArchivedProject
			}
		]

		if (!isMobile()) {
			buttonProps.push({
				size: 'big',
				level: 'low',
				isLoading: isDownloadLoading,
				callback: this.downloadZip,
				label: projectFolderChain.length ? 'Download folder' : 'Download all files',
				icon: 'fe-download',
				disabled: (isArchivedProject || !currentProject.files || !currentProject.files.length)
			})
		}

		buttonProps.push({
			size: 'big',
			level: 'low',
			callback: this.createFileFolder,
			label: 'New file folder',
			icon: 'folder-o',
			disabled: isArchivedProject
		})

		const hasFiles = currentProject.files && currentProject.files.length

		this.visibilityFilteredFiles = []
		this.allProjectFiles = []

		if (currentProject.files) {
			currentProject.files.forEach(fileId => {
				let fileObject = allFiles[fileId]

				if (!fileObject || !fileObject.latestVersion) {
					return
				}

				const currentFileFolderId = projectFolderChain.length ? projectFolderChain[(projectFolderChain.length - 1)] : null
				this.allProjectFiles.push(fileObject)

				if (fileObject.file_folder_id !== currentFileFolderId) {
					return
				}

				const isFileVisible = fileObject.name.toLowerCase().includes(searchTerm.toLowerCase())

				if (isFileVisible) {
					this.visibilityFilteredFiles.push(fileObject)
				}
			})
		}

		this.visibilityFilteredFiles.sort((a, b) => {
			return b.created_at.localeCompare(a.created_at)
		})

		let listClass = "files-grid-list"

		if (isList && !isMobile()) {
			listClass += " list"
			if (sortingData) {
				this.visibilityFilteredFiles = this.visibilityFilteredFiles.sort((a, b) => {
					let aText
					let bText
					let tempText // in case we need to swap direction

					let isDate = false
					let isNumber = false

					switch (sortingData.column) {
						case 'name':
							aText = a.name
							bText = b.name
							break
						case 'upload_date':
							isDate = true

							aText = a.latestVersion.created_at
							bText = b.latestVersion.created_at
							break
						case 'size':
							isNumber = true

							aText = a.latestVersion.size
							bText = b.latestVersion.size
							break
						case 'uploaded_by':
							const aUser = users[a.latestVersion.user_id] ? users[a.latestVersion.user_id] : null
							const bUser = users[a.latestVersion.user_id] ? users[b.latestVersion.user_id] : null

							aText = aUser ? aUser.first_name : 'zzz'
							bText = bUser ? bUser.first_name : 'zzz'

							break
						case 'type':
							aText = getFileExtension(a.latestVersion.filename)
							bText = getFileExtension(b.latestVersion.filename)

							if (!aText) {
								aText = 'zzz'
							}

							if (!bText) {
								bText = 'zzz'
							}
							break
					}

					if (sortingData.direction == 'desc') {
						tempText = aText
						aText = bText
						bText = tempText
					}

					if (!isNumber && !isDate) {
						aText = aText.toLowerCase()
						bText = bText.toLowerCase()
					}

					if (!isDate) {
						if (aText < bText) return -1
						if (aText > bText) return 1
						return 0
					} else {
						return aText.localeCompare(bText)
					}
				})
			}
		}

		const isLoadingFiles = !currentProject || !currentProject.hasFetchedFiles || (currentProject.files.length && !this.allProjectFiles.length)

		if (isLoadingFiles) {
			this.visibilityFilteredFiles = times(8).map(index => {
				return {
					id: index * -1,
					isLoading: true
				}
			})
		}

		if (isVisible) {
			listClass += ' visible'
		}

		if (blockFileTransition) {
			listClass += ' transitioning'
		}

		if (currentlyDraggedObject) {
			listClass += ' is-dragging'
		}

		const hasFolders = Object.keys(allFileFolders).length

		let alertBanner = {}

		if (!this.visibilityFilteredFiles.length) {
			if (!hasFiles) {
				alertBanner = {
					title: 'This project has no files.',
					body: "Store important files here."
				}
			} else if (projectFolderChain.length) {
				alertBanner = {
					title: 'This file folder is empty.',
					body: 'Use file folders to group files.'
				}
			} else if (hasFolders) {
				alertBanner = {
					title: `Nothing to see here.`,
					body: 'Open a folder to browse your files.'
				}
			} else {
				alertBanner = {
					title: `Nothing found for "${searchTerm}"`,
					body: 'Sorry about that.'
				}
			}
		}

		const slicedVisibilityFilteredFiles = chunk(this.visibilityFilteredFiles, this.numberOfColumns)


		return (
			<div
				className={className}
				onDrop={this.handleDrop}
				onDragOver={this.handleDragOver}
				onDragLeave={e => this.handleDragOver(e, true)}
			>
				<DropZoneIndicator />
				<MobileFooterButtons isForcedShut={isButtonsForcedShut} buttons={buttonProps} />
				<div className="files-left">
					<SectionControls
						buttons={buttonProps}
						toggleState={isList}
						toggleChangeCallback={this.toggleView}
						searchTerm={searchTerm}
						onSearchTermChange={this.onSearchTermChange}
						toggleOptions={this.toggleOptions}
					/>
					<ListHeading
						columns={[
							{
								label: 'Name',
								slug: 'name'
							}, {
								label: 'Upload date',
								slug: 'upload_date'
							}, {
								label: 'Size',
								slug: 'size'
							}, {
								label: 'Uploaded by',
								slug: 'uploaded_by'
							}, {
								label: 'Type',
								slug: 'type'
							}
						]}
						sortingData={sortingData}
						setSorting={this.setSorting}
						isVisible={isList == 1 && !isMobile()}
					/>
					{isVisible ?
						<ProjectFileFolders
							projectFolderChain={projectFolderChain}
							allFileFolders={allFileFolders}
							updateProjectFolderChain={updateProjectFolderChain}
							currentProject={currentProject}
							currentlyDraggedObject={currentlyDraggedObject}
							editFileFolder={this.editFileFolder}
							deleteFileFolder={this.deleteFileFolder}
							onDragStart={this.onDragStart}
							onDragEnd={this.onDragEnd}
							onDrop={this.onDrop}
							setlastHoveredFileFolder={this.setlastHoveredFileFolder}
							lastHoveredFileFolder={this.lastHoveredFileFolder}
							isList={isList}
							blockFileTransition={blockFileTransition}
						/>
						: null}
					{(this.visibilityFilteredFiles && hasFolders && !isList) ?
						<label className="separator">
							Files
					</label>
						: null}
					{isVisible ?
						<React.Fragment>
							{
								this.visibilityFilteredFiles.length ?
									slicedVisibilityFilteredFiles.map((group, groupIndex) => {
										const shouldRenderRow = visibleRows.indexOf(groupIndex) !== -1

										return (
											<div
												key={groupIndex}
												ref={ref => this.listRefs[groupIndex] = ref}
												className={listClass}
											>
												{ shouldRenderRow ?
													<Container
														onDrop={this.onDrop}
														onDragStart={this.onDragStart}
														onDragEnd={this.onDragEnd}
														orientation="horizontal"
														behaviour="copy"
														dragclassName="dragged-element"
														groupName="files"
														getChildPayload={index => {
															return {
																type: 'file',
																object: group[index]
															}
														}}
														render={setRef => (
															<ul
																ref={setRef}
																style={{ height: (this.cellHeight + 20) + 'px' }}
															>
																{ group.map((file, index) => {
																	if (index > lastRenderedIndex) {
																		return null
																	}

																	if (file.isLoading) {
																		return (
																			<Draggable key={index}>
																				<div>
																					<li className="list-item loading no-hover">
																						<div className={'loader-cover'} style={{
																							animationDelay: (index/10)+'s'
																						}}/>
																						<button>
																							<div className="file-grid-top" />
																							<div className="file-grid-meta" />
																						</button>
																					</li>
																				</div>
																			</Draggable>
																		)
																	}

																	const lastUser = find(users, user => {
																		return user.id === file.latestVersion.user_id
																	})

																	const normalisedIndex = (groupIndex * this.numberOfColumns) + index

																	let className = ''

																	if (currentlyDraggedObject && currentlyDraggedObject.type == 'file' && currentlyDraggedObject.object.id == file.id) {
																		className += ' is-being-dragged'
																	}

																	return (
																		<Draggable key={file.id}>
																			<div>
																				<ProjectFile
																					ref={ref => this.tileRefs[normalisedIndex] = (ref ? ref.ref : null)}
																					blockFileTransition={blockFileTransition}
																					index={index}
																					normalisedIndex={normalisedIndex}
																					lastUser={lastUser}
																					history={history}
																					matchPath={this.props.match.path}
																					file={file}
																					openPreviewModal={this.openPreviewModal}
																					shouldRender={true}
																					className={className}
																				/>
																			</div>
																		</Draggable>
																	)
																})}
															</ul>
														)} />
													:
													<div
														className="files-grid-row-spacer"
														style={{
															height: (isList ? this.cellHeight : this.cellHeight + 20) + 'px'
														}}
													/>
												}
											</div>
										)
									})
									:
									<AlertBanner title={alertBanner.title} body={alertBanner.body} />
							}
						</React.Fragment>
						: null}
				</div>
			</div>
		);
	}
}

const getFileFolders = createSelector(
	[
		state => state.account.entities.file_folders,
		(_, props) => props.currentProject,
	],
	(fileFolders, currentProject) => {
		const relevantFileFolders = {}

		forIn(fileFolders, fileFolder => {
			if (fileFolder.project_id == currentProject.id) {
				relevantFileFolders[fileFolder.id] = fileFolder
			}
		})

		return relevantFileFolders
	}
)

const mapStateToProps = (state, props) => ({
	allFiles: state.account.entities.files,
	allFileFolders: getFileFolders(state, props),
	users: state.account.entities.users,
	userData: getCurrentUser(state),
	accountData: getCurrentAccount(state)
})

export default withRouter(connect(mapStateToProps, {
	openModal,
	getZipOfFiles,
	togglePreference,
	setFileFolder,
	setFolderParent
})(ProjectFiles))